export enum PropertyType {
    String,
    Integer,
    Float,
    Time,
    Date,
    DateTime,
    Enum,
    BasicTable,
    ComplexTable
}
